import {isNullOrUndefined} from "util";
import {slugify} from "../authentication/utils";

export const makeFormData = ({
  translations,
  image,
  showOnSmartSearch,
  creating,
  type,
  synonyms,
  brand,
}) => {
  const form = new FormData()
  if (translations) {
    translations.forEach(translation => {
      if (!isNullOrUndefined(translation.name)) form.append(`translations[${translation.language}][name]`, translation.name);
    })
  }

  if (creating) form.append('slug', slugify(translations.filter(translation => translation.language == 'en')[0].name));
  if (image) form.append('image', image, image.name);
  if (!isNullOrUndefined(showOnSmartSearch)) form.append('show_on_smart_search', showOnSmartSearch ? 1 : 0)
  if (type) form.append('type', type)
  if (!isNullOrUndefined(synonyms)) form.append('synonyms', synonyms)
  if (!isNullOrUndefined(brand)) form.append('brand', brand)

  return form
};

export const root = '/contentCreatorTypes';

export const includeQuery = 'include=translations;image';
